(ns app.domain.licence.renewal-model
  "Locating the licence or contractor registration that a renewal workspace renews."
  (:require [app.domain.contractor-registration.model :as cr-model]
            [app.domain.licence.generic-model :as gl-model]
            [app.domain.licence.model :as licence-model]))

(defn renewal-workspace?
  "Whether this is a licence or contractor-registration renewal, without requiring its target to be loaded."
  [workspace]
  (boolean
    (case (:workspace/permit-type workspace)
      :permit-type/L (licence-model/renewal-workspace? workspace)
      :permit-type/CR (cr-model/renewal-workspace? workspace)
      false)))

(defn renewal-target
  "The licence or registration a renewal workspace renews, nil for other workspaces.
   If the renewal has no workspace yet, the L/CR is returned as is."
  [workspace-or-target]
  (case (:entity/type workspace-or-target)
    (:entity.type/licence :entity.type/contractor-registration)
    workspace-or-target

    :entity.type/workspace
    (or (when (licence-model/renewal-workspace? workspace-or-target)
          (licence-model/workspace-licence workspace-or-target))
        (when (cr-model/renewal-workspace? workspace-or-target)
          (cr-model/workspace-registration workspace-or-target)))

    nil))

(defn renewal-due-date
  "Expiry of the renewed licence or registration, used as the due date of renewal bills."
  [workspace-or-target]
  (some-> workspace-or-target renewal-target gl-model/get-valid-to))
